import { ProductDoc } from '@gooduncles/gu-app-schema';
import { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import ProductDetail from 'src/components/templates/ProductDetail/ProductDetail';

const ProductDetailPage: FC = () => {
  const { productId } = useParams<{ productId: ProductDoc['_id'] }>();
  return productId ? <ProductDetail productId={productId} /> : <Navigate to='/' replace />;
};

export default ProductDetailPage;
